// src/pages/QuickOrder.js
import React, { useState, useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
import axios from "axios";
import ImageSlider from "./ImageSlider";
import CartTable from "./CartTable";
import ProductForm from "./ProductForm";
import MapsProvider from "../components/MapsProvider";
import Swal from 'sweetalert2';
import "../assets/css/QuickOrder.css"; 
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";


const API_BASE_URL = process.env.REACT_APP_API_URL;

const QuickOrderPage = () => {
  const location = useLocation();
  const { campaignId } = useParams();
  const [products, setProducts] = useState([]);
  const [cart, setCart] = useState(() => {
    const stored = localStorage.getItem("cart");
    return stored ? JSON.parse(stored) : [];
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/campaign/${campaignId}/products`);
        setProducts(response.data.products);
      } catch (err) {
        setError("Error fetching products for this campaign.");
      } finally {
        setLoading(false);
      }
    };
    fetchProducts();
  }, [campaignId]);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const isSuccess = queryParams.get("success");
    const isCanceled = queryParams.get("canceled");
    const orderNumber = queryParams.get("orderNumber");

    if (isSuccess === "true") {
      try {
        axios.post(`${API_BASE_URL}/campaign/paid-order`, { orderNumber });
      } catch (error) {
        console.error("Stripe error:", error);
      }
      setCart([]);
      localStorage.removeItem("cart");
      window.history.replaceState(null, "", window.location.pathname);
      Swal.fire({
        title: 'Success!',
        text: 'Your order has been placed.',
        icon: 'success',
        confirmButtonText: 'OK'
      });
    }

    if (isCanceled === "true") {
      try {
        axios.post(`${API_BASE_URL}/campaign/cancel-order`, { orderNumber });
      } catch (error) {
        console.error("Stripe error:", error);
      }
      window.history.replaceState(null, "", window.location.pathname);
    }
  }, [location.search]);

  useEffect(() => {
    localStorage.setItem("cart", JSON.stringify(cart));
  }, [cart]);

  const addToCart = (item) => setCart((prevCart) => [...prevCart, item]);
  const removeFromCart = (index) =>
    setCart((prevCart) => prevCart.filter((_, i) => i !== index));

  if (loading)
    return (
      <div className="centered-message">
        <span className="loader-dot" aria-hidden="true" />
        Loading products...
      </div>
    );
  if (error)
    return (
      <div className="centered-message">
        <h2>This campaign is not available</h2>
        <p>
          It may have closed, or the link might be out of date. Have a look at what is open right
          now.
        </p>
        <Link to="/order-now" className="btn">
          See open campaigns
        </Link>
      </div>
    );

  return (
                <>
                <Helmet>
                  <title>Quick Order – Farmer Boaz</title>
                  <meta name="description" content="Choose your cuts and sizes, then check out securely. Farm-fresh community shares from Farmer Boaz." />
                </Helmet>
    <div className="quick-order-page">
      <ImageSlider />

      <h1 className="quick-order-title">Quick Order</h1>
      <p className="quick-order-intro">
        Add the cuts and sizes you want, then review your cart and check out securely. Delivery is
        within 7 business days of the campaign closing.
      </p>
      <div className="quick-order-sections">
        <div className="quick-order-section card">
          <h2 className="section-title">Add Product</h2>
          <ProductForm products={products} addToCart={addToCart} />
        </div>
        <div className="quick-order-section card">
          <h2 className="section-title">Your Cart</h2>
          <MapsProvider>
            <CartTable cart={cart} setCart={setCart} campaignId={campaignId} removeFromCart={removeFromCart} />
          </MapsProvider>
        </div>
      </div>
    </div>
    </>
  );
};

export default QuickOrderPage;
